import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcBan(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.25c5.384 0 9.75 4.365 9.75 9.75s-4.366 9.75-9.75 9.75S2.25 17.384 2.25 12 6.615 2.25 12 2.25M5.738 6.82A8.1 8.1 0 0 0 3.875 12a8.125 8.125 0 0 0 13.302 6.26zm6.261-2.945a8.1 8.1 0 0 0-5.105 1.804l11.425 11.425a8.125 8.125 0 0 0-6.32-13.23"
  }));
}
var IcBan = createNolIcon(/*#__PURE__*/forwardRef(SvgIcBan));

export { IcBan as I };
